import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getCleanerReportCategory = createAsyncThunk('cleanerReport/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/cleaning-reports-category/get-cleaning-reports-category`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addcleanerReportCategory = createAsyncThunk('cleanerReport/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/cleaning-reports-category/create-cleaning-reports-category`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editcleanerReportCategory = createAsyncThunk('cleanerReport/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(
      `/cleaning-reports-category/update-cleaning-reports-category/${data?.cleanerReportCategoryID}`,
      data?.data
    )
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deletecleanerReportCategory = createAsyncThunk('cleanerReport/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/cleaning-reports-category/delete-cleaning-reports-category/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allCleanerReportCategoryData: [],
  error: null
}

const cleanerReportSlice = createSlice({
  name: 'cleanerReport',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getCleanerReportCategory.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCleanerReportCategory.fulfilled, (state, action) => {
        state.isLoading = false
        state.allCleanerReportCategoryData = action.payload?.data?.data
      })
      .addCase(getCleanerReportCategory.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addcleanerReportCategory.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addcleanerReportCategory.fulfilled, (state, action) => {
        state.isLoading = false
        state.admin = action.payload?.data?.data
      })
      .addCase(addcleanerReportCategory.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default cleanerReportSlice.reducer
